<template>
  <div :class="[themeCls, {[`${themeDisCls}`]: !this.canClick}]" @click="countDown">
    {{content}}
  </div>
</template>

<script>
import { MOBILE_CAPTCHA } from '@/api/system';

const themeArray = [''];
const codeTemplateArray = ['login', 'register'];

const btnCls = 'count-down-btn';
const btnDisCls = 'disabled-btn';
const defaultCodeTemp = 'login';

let clock;

export default {
  name: 'verifyCode',
  props: ['mobile', 'theme', 'codeTemplate'],
  data() {
    return {
      defaultTime: 120,
      themeCls: themeArray.includes(this.theme) ? `${btnCls}-${this.theme}` : `${btnCls}`,
      themeDisCls: themeArray.includes(this.theme) ? `${btnDisCls}-${this.theme}` : `${btnDisCls}`,
      ct: codeTemplateArray.includes(this.codeTemplate) ? this.codeTemplate : defaultCodeTemp,
      content: '获取验证码',
      totalTime: 120,
      canClick: true,
    };
  },
  methods: {
    countDown() {
      const mobileRegExp = /^1\d{10}$/;
      if (!mobileRegExp.test(this.mobile)) {
        this.$message({
          message: '手机号码不正确',
          type: 'warn',
          duration: 3000,
          showClose: true,
        });
        return;
      }
      if (!this.canClick) {
        return;
      }
      this.canClick = false;
      this.content = `${this.totalTime}`;
      clock = window.setInterval(() => {
        this.totalTime -= 1;
        this.content = this.totalTime;
        if (this.totalTime < 0) {
          this.resetStatus();
        }
      }, 1000);
      this.sendCode();
    },
    resetStatus() {
      window.clearInterval(clock);
      this.content = '重新发送';
      this.totalTime = this.defaultTime;
      this.canClick = true;
    },
    sendCode() {
      const params = { cellPhone: this.mobile, codeTemplate: this.ct };
      this.$axios.jsonPost(MOBILE_CAPTCHA, params).then((result) => {
        if (result.code !== 0) {
          this.resetStatus();
        }
      });
    },
  },
};

</script>

<style lang="scss" scoped>
   @import '~@/theme/app.scss';

  @mixin countDownCls($bgColor, $fontColor) {
    margin: 0;
    width: 100%;
    min-width: 5rem;
    padding: 10px 0px;
    text-align: center;
    white-space: nowrap;
    cursor: pointer;
    line-height: 1.429;
    font-size: 0.8rem;
    background: $bgColor;
    color: $fontColor;
    outline: none;
    border: none;
    border-radius: 2px;
    box-sizing: border-box;
    z-index: 100;
  }

  .count-down-btn {
    @include countDownCls($login-background-color, $login-button-color);
  }

  @mixin disabledCls($bgColor, $fontColor) {
    background-color: $bgColor;
    color: $fontColor;
    cursor: not-allowed;
  }
  .disabled-btn {
    @include disabledCls($login-background-color, $font-color);
  }

</style>
